import { TrendingUp, TrendingDown, Minus } from 'lucide-react'

interface KpiCardProps {
  label: string
  value: string | number
  subtitle?: string
  trend?: {
    value: number
    label: string
  }
  accentColor?: string
  icon?: React.ComponentType<{ className?: string }>
}

export function KpiCard({ label, value, subtitle, trend, accentColor, icon: Icon }: KpiCardProps) {
  const trendDirection = trend ? (trend.value > 0 ? 'up' : trend.value < 0 ? 'down' : 'flat') : null

  return (
    <div
      className="rounded-lg border p-5"
      style={{
        backgroundColor: 'var(--color-surface)',
        borderColor: 'var(--color-border)',
        borderLeftWidth: '4px',
        borderLeftColor: accentColor ?? 'var(--color-brand-secondary)',
        boxShadow: 'var(--shadow-sm)',
      }}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium" style={{ color: 'var(--color-text-secondary)' }}>
            {label}
          </p>
          <p
            className="mt-1 text-3xl font-bold tabular-nums"
            style={{ color: 'var(--color-text-primary)' }}
          >
            {value}
          </p>
          {subtitle && (
            <p className="mt-1 text-sm" style={{ color: 'var(--color-text-tertiary)' }}>
              {subtitle}
            </p>
          )}
        </div>
        {Icon && (
          <div
            className="rounded-lg p-2"
            style={{ backgroundColor: 'var(--color-brand-primary-50)' }}
          >
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>

      {trend && (
        <div className="mt-3 flex items-center gap-1.5">
          {trendDirection === 'up' && (
            <TrendingUp className="h-4 w-4" style={{ color: 'var(--color-success)' }} />
          )}
          {trendDirection === 'down' && (
            <TrendingDown className="h-4 w-4" style={{ color: 'var(--color-error)' }} />
          )}
          {trendDirection === 'flat' && (
            <Minus className="h-4 w-4" style={{ color: 'var(--color-text-tertiary)' }} />
          )}
          <span
            className="text-sm font-medium"
            style={{
              color:
                trendDirection === 'up'
                  ? 'var(--color-success)'
                  : trendDirection === 'down'
                    ? 'var(--color-error)'
                    : 'var(--color-text-tertiary)',
            }}
          >
            {trend.value > 0 ? '+' : ''}
            {trend.value}%
          </span>
          <span className="text-sm" style={{ color: 'var(--color-text-tertiary)' }}>
            {trend.label}
          </span>
        </div>
      )}
    </div>
  )
}
